import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';

export interface IDialogProps {
    title?: string
    content: any
    onClose?: (id: number) => void
    onSuccess?: (id: number) => void
}

export interface IDialogPropsWithId extends IDialogProps {
    id: number
}

function Dialog({ id, title, content, onClose, onSuccess }: IDialogPropsWithId) {
    const [close, setClose] = useState(false);

    const closeHandler = () => {
        setClose(true);
        onClose && onClose(id);
    }

    if (close) return null;

    return (
        <div
            className='dialog'
            onClick={(e) => {
                e.stopPropagation();
                closeHandler();
            }}>
            <div
                className='window scrollWindow'
                onClick={(e) => e.stopPropagation()}>
                <div
                    style={{ flexDirection: 'column' }}
                    className='display-flex'>
                    <div>
                        <div className='display-flex'>
                            <div className='title w-100'>{title}</div>
                            <button
                                className='cursor-pointer h-21 p-3-6'
                                onClick={closeHandler}>
                                <FontAwesomeIcon
                                    icon={icon({ name: 'close' })}
                                    size='sm' />
                            </button>
                        </div>
                    </div>
                    <div className='content'>
                        {content}
                    </div>
                    {
                        onSuccess &&
                        <div className='footer'>
                            <button
                                className='cursor-pointer p-5 text-info border-info'
                                onClick={() => onSuccess(id)}>
                                ok
                            </button>
                            <button
                                className='cursor-pointer p-5 text-error border-error'
                                onClick={closeHandler}>
                                zrušit
                            </button>
                        </div>
                    }
                </div>
            </div >
        </div >
    );
}

export default Dialog;
